export { setAttribute, trackAttribute } from "./attribute";
export { autofocus, setCheckArgument as setAutoFocusCheckArgument } from "./autofocus";
export { clickOutside, listen } from "./events";
export { focusTrap, focusable, returnFocus, scrollLock } from "./focus";
export { escape, keyUpDown, keydown } from "./keyboard";
export { place, type AlignModes as PlaceAlignModes } from "./place";
export { portal } from "./portal";
export { useActions } from "./use-actions";

export type SvelteActionReturn<P = any> = {
  update?: (params?: P) => void;
  destroy?: () => void;
} | void;

export type SvelteAction<P = any> = (element: HTMLElement, params?: P) => SvelteActionReturn<P>;

export type SvelteActionArray<P = any> = Array<SvelteAction<P> | [SvelteAction<P>, P]>;

export function unify<P>(destroies: Array<SvelteActionReturn<P>>) {
  const destroys = destroies
    .filter(
      (d): d is Exclude<SvelteActionReturn<P>, void> =>
        d != null && typeof d !== "undefined" && typeof d.destroy === "function",
    )
    .map((d) => d.destroy);
  return {
    destroy() {
      destroys.forEach((destroy) => destroy());
    },
  };
}
